// ERP Billing Service enum'lari.
// Manba: https://staging-savdo.hippo.uz/billing/swagger/index.html (types.PackageCode,
// types.PackageItemCode, types.PackageItemKind). Qiymatlar backend bilan aynan bir xil
// bo'lishi shart — o'zgartirishdan oldin swagger'ni tekshiring.

// types.PackageCode
export const PACKAGE_CODE_BASE = 'base';
export const PACKAGE_CODE_BASE_PRO = 'base_pro';
export const PACKAGE_CODE_MEDIUM = 'medium';
export const PACKAGE_CODE_PREMIUM = 'premium';
export const PACKAGE_CODE_BASE_DEMO = 'base_demo';
export const PACKAGE_CODE_BASE_PRO_DEMO = 'base_pro_demo';
export const PACKAGE_CODE_BASE_PRO_3_PLUS_1 = 'base_pro_3_plus_1';

export const PackageCodes = {
    [PACKAGE_CODE_BASE]: {code: PACKAGE_CODE_BASE, label: 'main.billing.package.code.base'},
    [PACKAGE_CODE_BASE_PRO]: {code: PACKAGE_CODE_BASE_PRO, label: 'main.billing.package.code.base_pro'},
    [PACKAGE_CODE_MEDIUM]: {code: PACKAGE_CODE_MEDIUM, label: 'main.billing.package.code.medium'},
    [PACKAGE_CODE_PREMIUM]: {code: PACKAGE_CODE_PREMIUM, label: 'main.billing.package.code.premium'},
    [PACKAGE_CODE_BASE_DEMO]: {code: PACKAGE_CODE_BASE_DEMO, label: 'main.billing.package.code.base_demo'},
    [PACKAGE_CODE_BASE_PRO_DEMO]: {code: PACKAGE_CODE_BASE_PRO_DEMO, label: 'main.billing.package.code.base_pro_demo'},
    [PACKAGE_CODE_BASE_PRO_3_PLUS_1]: {code: PACKAGE_CODE_BASE_PRO_3_PLUS_1, label: 'main.billing.package.code.base_pro_3_plus_1'},
};

export const packageCodeOptions = Object.keys(PackageCodes).map(key => PackageCodes[key]);

// types.PackageItemCode — kvota (account, warehouse) va feature (telegram_*_bot) kodlari.
export const PACKAGE_ITEM_CODE_ACCOUNT = 'account';
export const PACKAGE_ITEM_CODE_WAREHOUSE = 'warehouse';
export const PACKAGE_ITEM_CODE_TELEGRAM_ORDER_BOT = 'telegram_order_bot';
export const PACKAGE_ITEM_CODE_TELEGRAM_ADMIN_BOT = 'telegram_admin_bot';

export const PackageItemCodes = {
    [PACKAGE_ITEM_CODE_ACCOUNT]: {code: PACKAGE_ITEM_CODE_ACCOUNT, label: 'main.billing.package.item.code.account'},
    [PACKAGE_ITEM_CODE_WAREHOUSE]: {code: PACKAGE_ITEM_CODE_WAREHOUSE, label: 'main.billing.package.item.code.warehouse'},
    [PACKAGE_ITEM_CODE_TELEGRAM_ORDER_BOT]: {code: PACKAGE_ITEM_CODE_TELEGRAM_ORDER_BOT, label: 'main.billing.package.item.code.telegram_order_bot'},
    [PACKAGE_ITEM_CODE_TELEGRAM_ADMIN_BOT]: {code: PACKAGE_ITEM_CODE_TELEGRAM_ADMIN_BOT, label: 'main.billing.package.item.code.telegram_admin_bot'},
};

// types.PackageItemKind
export const PACKAGE_ITEM_KIND_QUOTA = 1;
export const PACKAGE_ITEM_KIND_FEATURE = 2;

/**
 * Paket kodi uchun ko'rsatiladigan nom.
 * Backend'dan kelgan name ustun, aks holda tarjima kaliti, oxirgi chora — kodning o'zi.
 *
 * @param {string} code types.PackageCode qiymati
 * @param {string} lang joriy til
 * @param {function} t Translate funksiyasi
 * @param {string} [name] backend qaytargan paket nomi
 * @returns {string}
 */
export const getPackageCodeLabel = (code, lang, t, name) => {
    if (name) return name;
    const known = PackageCodes[code];
    if (known) {
        const translated = t(lang, known.label);
        // Translate topilmagan kalitni o'zini qaytaradi — bunday holda kodni ko'rsatamiz.
        if (translated !== known.label) return translated;
    }
    return code || '';
};

/**
 * Paket item kodi uchun ko'rsatiladigan nom.
 *
 * @param {string} code types.PackageItemCode qiymati
 * @param {string} lang joriy til
 * @param {function} t Translate funksiyasi
 * @returns {string}
 */
export const getPackageItemCodeLabel = (code, lang, t) => {
    const known = PackageItemCodes[code];
    if (known) {
        const translated = t(lang, known.label);
        if (translated !== known.label) return translated;
    }
    return code || '';
};
